module.exports = __webpack_public_path__ + "media/cash.da5fd762.mp3";